import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import styles from '../../styles/Hero.module.css';
import logoImage from '../../assets/images/logo.png';
import textLogoImage from '../../assets/images/olym_text_logo.png';

export default function Hero() {
  const [heroRef, isVisible] = useScrollAnimation({ once: true });

  return (
    <section id="hero" ref={heroRef} className={`${styles.hero} ${isVisible ? styles.visible : ''}`}>
      {/* 배경 올림 로고 그래픽 */}
      <div className={styles.bgLogo}>
        <img src={logoImage} alt="" className={styles.bgLogoImage} />
      </div>

      <div className={styles.content}>
        {/* 로고 */}
        <div className={styles.logoContainer}>
          <img src={textLogoImage} alt="olym" className={styles.textLogo} />
        </div>

        {/* 메인 타이틀 */}
        <h1 className={styles.title}>
          스포츠 예약
          <br />
          이제 쇼핑처럼 쉽게
        </h1>

        {/* 서브 타이틀 */}
        <p className={styles.subtitle}>
          올인원 스포츠 플랫폼
        </p>
        <p className={styles.features}>
          예약 · 결제 · 일정 · 정산 · 고객관리 올림 하나로 해결
        </p>

        {/* CTA 버튼 */}
        <div className={styles.cta}>
          <a href="https://admin.olym.kr/onboarding" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
            무료로 시작하기
          </a>
        </div>

        {/* 고객 페이지 링크 */}
        <div className={styles.customerLink}>
          <a href="/#hero">고객이신가요? 편리한 스포츠 예약 플랫폼 올림을 확인해보세요 →</a>
        </div>
      </div>

      {/* 스크롤 다운 인디케이터 */}
      <div className={styles.scrollIndicator}>
        <div className={styles.scrollMouse}>
          <div className={styles.scrollWheel}></div>
        </div>
        <span className={styles.scrollText}>Scroll Down</span>
      </div>
    </section>
  );
}
